import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { pixTransfer } from '@ibk/shared-assets';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { pagamentosTranslations } from '../../translations';
import styles from './PixTransferCard.module.css';
function PixTransferCardBase(props) {
    const { dataTestId = 'pix-transfer-card', onClick } = props;
    const { t } = useTranslation();
    return (_jsxs("button", { className: styles.card, onClick: onClick, "data-testid": dataTestId, type: 'button', children: [_jsx("div", { className: styles.iconContainer, "data-testid": `${dataTestId}-icon-container`, children: _jsx("img", { src: pixTransfer, alt: 'Transferir via Pix', className: styles.icon, "data-testid": `${dataTestId}-icon` }) }), _jsx("span", { className: styles.title, "data-testid": `${dataTestId}-title`, children: t('transfer-via-pix') })] }));
}
export function PixTransferCard(props) {
    return (_jsx(TranslationProvider, { translations: pagamentosTranslations, defaultLanguage: 'pt-BR', children: _jsx(PixTransferCardBase, { ...props }) }));
}
